import React from 'react'
import { useRouter } from 'next/router'
import { Layout } from '@components/layout'
import { GetServerSideProps } from 'next'
import { Menu, MenusApi } from '@services/api/menus'
import { HeadMetadata } from '@components/head-metadata'
import Script from 'next/script'
import { GA_SIMULATION_FINISHED_ID } from '@utils/gtag'

const Finalizado: React.FC<{
  main: Menu[]
  footer1: Menu[]
  footer2: Menu[]
}> = ({ main, footer1, footer2 }) => {
  const router = useRouter()

  return (
    <Layout
      mainMenus={main}
      footerMenus1={footer1}
      footerMenus2={footer2}
      title="Simulador Solar - Descubra quando custa instalar energia solar"
    >
      <HeadMetadata
        title="Simulador Solar - Descubra quando custa instalar energia solar"
        metaTitle="Simulador Solar - Descubra quando custa instalar energia solar"
        metaDescription="Descubra rapidamente qual é o tamanho do gerador solar fotovoltaico que sua propriedade precisa. Clique aqui e conheça nosso cálculo solar."
      />

      {/* Event snippet for B2C | Acelera | Conversão Finalizado | 8/3/23 conversion page */}
      <Script
        dangerouslySetInnerHTML={{
          __html: `
          gtag('event', 'conversion', {'send_to': '${GA_SIMULATION_FINISHED_ID}/X8nrCNnk1JAYEKiFs9UD'});
          `
        }}
      />
      <div className="flex flex-col items-center">
        <div className="mt-24 w-80 text-center font-sans">
          <h1 className="self-center text-orange font-serif text-4xl font-black">
            Obrigado!
          </h1>
          <h3 className="text-2xl mt-4">
            Seu pedido de cotação foi enviado com sucesso!
          </h3>
          <h3 className="mt-10 text-2xl">
            Em breve, alguém da nossa equipe entrará em contato com você por
            e-mail ou telefone.
          </h3>
          <button
            onClick={() => {
              router.push('/')
            }}
            className="mt-28 btn btn-orange-outline mx-4"
          >
            voltar ao site
          </button>
        </div>
      </div>
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async () => {
  const menus = await MenusApi.all()

  return {
    props: {
      ...menus
    }
  }
}

export default Finalizado
